export const DATA_HOOKS = {
  sortDropdown: 'sort-dropdown',
  searchSortingBox: 'search-sorting-box',
};
